var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMinus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  "data-figma-bg-blur-radius": 24
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fillOpacity: 0.1,
  rx: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.834 17.375a.626.626 0 0 1 0 1.25H12.167a.625.625 0 1 1 0-1.25z"
}))));
export default SvgIconMinus;